import * as React from "react";

export const IconFactCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14zM5 7h5v2H5V7zm0 4h5v2H5v-2zm0 4h5v2H5v-2zm14.41-4.58-1.42-1.42-3.17 3.17-1.41-1.42-1.41 1.41 2.82 2.84 4.59-4.58z"
      fill="currentColor"
    />
  </svg>
);
